import React, { useState, useEffect, useRef } from 'react';
import { LoadingSpinner } from '../common/LoadingSpinner';
import DataService from '../../services/DataService';

export const TextView: React.FC<{ questionId: string | null }> = ({ questionId }) => {
  const [verses, setVerses] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!questionId) {
      setLoading(false);
      setError('No question selected');
      return;
    }

    const loadVerses = () => {
      setLoading(true);
      setError(null);
      
      try {
        const verseId = parseInt(questionId);
        
        // Get the verse data
        const verse = DataService.getVerseByVid(verseId);
        if (!verse) {
          setError('Verse not found');
          setLoading(false);
          return;
        }
        
        setPage(verse.page);
        
        // Get all verses from this page and next page
        const pageVerses = DataService.getVersesByPage(verse.page);
        const nextPageVerses = DataService.getVersesByPage(verse.page + 1);
        
        // Combine and filter from the selected verse
        const allVerses = [...pageVerses, ...nextPageVerses];
        const filtered = allVerses.filter((v: any) => v.vid >= verseId);
        
        setVerses(filtered);
      } catch (err) {
        setError('Error loading verses');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadVerses();
  }, [questionId]);

  if (loading) return <LoadingSpinner />;

  if (error) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center w-full">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  if (verses.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center w-full">
        <p className="text-gray-500">No verses found</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 w-full overflow-x-auto">
      <div 
        ref={containerRef}
        className="viewcontainer w-full"
        dir="rtl"
      >
        <div className=" text-justify leading-loose break-words">
          {verses.map((verse, index) => (
            <span 
              key={verse.vid} 
              className="ayah "
            >
              {/* Show verse text without any extra spacing that might force line breaks */}
              {verse.verse_text_vn || verse.verse_text}
              {/* Add a decorative separator between verses (optional) */}
              {index < verses.length - 1 && (
                <span className="text-purple-400 mx-0.5" style={{ fontSize: '0.6em' }}>
                  { ' '}
                  {/* {window.innerWidth > 640 ? ' ۞ ' : ' '} */}
                </span>
              )}
            </span>
          ))}
        </div>
      </div>
      {page > 0 && (
        <div className="text-center mt-6 text-gray-500 border-t pt-4">
          <span className="pagehead">Page: {page}</span>
          {verses.length > 1 && (
            <span className="text-sm ml-4">({verses.length} verses)</span>
          )}
        </div>
      )}
    </div>
  );
};